import React, { useState } from "react";
import { Modal, Button } from 'react-bootstrap';
import CustomTable from "../../components/common/CustomTable";
import TranslateFile from "../../Loc/TranslateFile";

const NotesModal = ({ notesData, onClose }) => {
    const currentLang = TranslateFile()

    const feedbackColumn = [
        {
            name: "Item #",
            selector: (row) => row.NotesSNo,
            sortable: false,
            width: '120px',
        },
        {
            width: '180px',
            name: "Date",
            selector: (row) => row.PdsNotesDate,
            cell: (row, i) => (
                <div>
                    <i className="fa-solid fa-calendar-days font-size-16 me-2" aria-hidden="true"></i>
                    <span>{row.PdsNotesDate}</span>
                </div>
            ),

            sortable: false,
        },
        {
            name: "Notes",
            selector: (row) => row.NotesRemarks,
            sortable: false,
        },
    ];

    return (

        <Modal show={true} onHide={onClose} backdrop="static" centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Feedback from Public Defender</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CustomTable columns={feedbackColumn} data={notesData} />
            </Modal.Body>
            <Modal.Footer><div>
                <button className="btn button-primary" onClick={onClose} title="Close">
                    {currentLang?.Buttons?.Close}
                </button>
            </div>
            </Modal.Footer>
        </Modal>
    );
};

export default NotesModal;
